import React from 'react';
import { Check, Sparkles, ArrowRight, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { AnimatedSection } from './AnimatedSection';
import { useCart } from '../../contexts/CartContext';
import { pricingCards, cardAccents } from './homeData';
interface PricingSectionProps {
  onNavigate: (page: string) => void;
}
export function PricingSection({
  onNavigate
}: PricingSectionProps) {
  const {
    addItem
  } = useCart();
  const handleBuyPackage = (pkg: {
    title: string;
    desc: string;
    price: string;
    oldPrice?: string | null;
  }) => {
    const priceNum = parseInt(pkg.price.replace(/[^\d]/g, ''));
    const oldPriceNum = pkg.oldPrice ? parseInt(pkg.oldPrice.replace(/[^\d]/g, '')) : undefined;
    addItem({
      id: `pkg-${Date.now()}`,
      name: pkg.title,
      description: pkg.desc,
      price: priceNum,
      type: 'package',
      format: 'PDF-отчёты',
      duration: 'Бессрочно',
      oldPrice: oldPriceNum,
      badges: [{
        label: 'Пакет отчётов',
        variant: 'success'
      }]
    });
    onNavigate('checkout');
  };
  const singlePricing = <div data-id="element-16027">
      <div className="relative mt-6" data-id="element-16028">
        <div className="xl:hidden absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-16029" />
        <div className="xl:hidden absolute right-0 top-0 bottom-0 w-4 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-16030" />
        <div className="flex gap-3 overflow-x-auto xl:overflow-x-visible pb-4 xl:pb-0 snap-x snap-mandatory xl:snap-none -mx-1 px-1 xl:mx-0 xl:px-0 xl:grid xl:grid-cols-5" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-16031">
          {pricingCards.map((card, idx) => {
          const accent = cardAccents[idx];
          if (card.popular) {
            return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-16032">
                  <div className="relative h-full" data-id="element-16033">
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10" data-id="element-16034">
                      <span className="bg-white text-indigo-600 text-[11px] font-bold px-3 py-1 rounded-full shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-16035">
                        <Sparkles className="w-3 h-3" data-id="element-16036" />
                        Популярно
                      </span>
                    </div>
                    <div className="bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-600 rounded-2xl p-4 xl:p-5 flex flex-col h-full shadow-xl shadow-indigo-500/20" data-id="element-16037">
                      <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3 mt-1`} data-id="element-16038">
                        {accent.icon}
                      </div>
                      <h3 className="text-[15px] font-bold text-white mb-1 leading-tight" data-id="element-16039">
                        {card.title}
                      </h3>
                      <p className="text-indigo-200 text-xs mb-3 flex-grow leading-relaxed" data-id="element-16040">
                        {card.desc}
                      </p>
                      <ul className="space-y-1.5 mb-4 text-xs text-indigo-100" data-id="element-16041">
                        {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-16042">
                            <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-16043">
                              <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-16044" />
                            </div>
                            {f}
                          </li>)}
                      </ul>
                      <div className="flex items-baseline gap-1.5 mb-0.5" data-id="element-16045">
                        <span className="text-xl font-bold text-white" data-id="element-16046">
                          {card.price}
                        </span>
                        <span className="text-xs text-indigo-200 line-through" data-id="element-16047">
                          {card.oldPrice}
                        </span>
                      </div>
                      <span className="text-[11px] font-semibold text-emerald-300 mb-3" data-id="element-16048">
                        Выгода 17%
                      </span>
                      <Button fullWidth variant="outline" className="!bg-white !text-indigo-600 !border-white/30 hover:!bg-indigo-50 text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-16049">
                        Выбрать
                      </Button>
                    </div>
                  </div>
                </div>;
          }
          return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-16050">
                <div className={`relative bg-gradient-to-b ${accent.tint} to-white rounded-2xl border border-slate-200/80 border-t-2 ${accent.border} p-4 xl:p-5 h-full flex flex-col`} data-id="element-16051">
                  <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3`} data-id="element-16052">
                    {accent.icon}
                  </div>
                  <h3 className="text-[15px] font-bold text-slate-900 mb-1 leading-tight" data-id="element-16053">
                    {card.title}
                  </h3>
                  <p className="text-slate-500 text-xs mb-3 flex-grow leading-relaxed" data-id="element-16054">
                    {card.desc}
                  </p>
                  <ul className="space-y-1.5 mb-4 text-xs text-slate-600" data-id="element-16055">
                    {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-16056">
                        <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-16057">
                          <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-16058" />
                        </div>
                        {f}
                      </li>)}
                  </ul>
                  <div className="text-xl font-bold text-slate-900 mb-3" data-id="element-16059">
                    {card.price}
                  </div>
                  <Button fullWidth variant="outline" className="text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-16060">
                    Выбрать
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
      <div className="text-center mt-5" data-id="element-16061">
        <Button variant="ghost" className="text-slate-500" onClick={() => onNavigate('pricing')} data-id="element-16062">
          Все цены и услуги <ArrowRight className="ml-2 w-4 h-4" data-id="element-16063" />
        </Button>
      </div>
    </div>;
  return <AnimatedSection className="py-8 sm:py-16 bg-white" data-id="element-16064">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16065">
        <div className="text-center mb-4 sm:mb-8" data-id="element-16066">
          <div className="inline-flex items-center px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-slate-100 text-slate-600 text-[10px] sm:text-xs font-semibold uppercase tracking-[0.15em] mb-3 sm:mb-4" data-id="element-16067">
            <Shield className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1.5 sm:mr-2" data-id="element-16068" />
            Прозрачные цены
          </div>
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-16069">
            Наши услуги и цены
          </h2>
          <p className="text-xs sm:text-lg text-slate-500 max-w-xl mx-auto" data-id="element-16070">
            Простые цены без скрытых платежей. Гарантия возврата 7 дней.
          </p>
        </div>

        <div data-id="element-16071">
          <div className="relative mt-6" data-id="element-16072">
            <div className="xl:hidden absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-16073" />
            <div className="xl:hidden absolute right-0 top-0 bottom-0 w-4 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-16074" />
            <div className="flex gap-3 overflow-x-auto xl:overflow-x-visible pb-4 xl:pb-0 snap-x snap-mandatory xl:snap-none -mx-1 px-1 xl:mx-0 xl:px-0 xl:grid xl:grid-cols-5" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-16075">
              {pricingCards.map((card, idx) => {
              const accent = cardAccents[idx];
              if (card.popular) {
                return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-16076">
                      <div className="relative h-full" data-id="element-16077">
                        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10" data-id="element-16078">
                          <span className="bg-white text-indigo-600 text-[11px] font-bold px-3 py-1 rounded-full shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-16079">
                            <Sparkles className="w-3 h-3" data-id="element-16080" />
                            Популярно
                          </span>
                        </div>
                        <div className="bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-600 rounded-2xl p-4 xl:p-5 flex flex-col h-full shadow-xl shadow-indigo-500/20" data-id="element-16081">
                          <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3 mt-1`} data-id="element-16082">
                            {accent.icon}
                          </div>
                          <h3 className="text-[15px] font-bold text-white mb-1 leading-tight" data-id="element-16083">
                            {card.title}
                          </h3>
                          <p className="text-indigo-200 text-xs mb-3 flex-grow leading-relaxed" data-id="element-16084">
                            {card.desc}
                          </p>
                          <ul className="space-y-1.5 mb-4 text-xs text-indigo-100" data-id="element-16085">
                            {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-16086">
                                <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-16087">
                                  <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-16088" />
                                </div>
                                {f}
                              </li>)}
                          </ul>
                          <div className="flex items-baseline gap-1.5 mb-0.5" data-id="element-16089">
                            <span className="text-xl font-bold text-white" data-id="element-16090">
                              {card.price}
                            </span>
                            <span className="text-xs text-indigo-200 line-through" data-id="element-16091">
                              {card.oldPrice}
                            </span>
                          </div>
                          <span className="text-[11px] font-semibold text-emerald-300 mb-3" data-id="element-16092">
                            Выгода 17%
                          </span>
                          <Button fullWidth variant="outline" className="!bg-white !text-indigo-600 !border-white/30 hover:!bg-indigo-50 text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-16093">
                            Выбрать
                          </Button>
                        </div>
                      </div>
                    </div>;
              }
              return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-16094">
                    <div className={`relative bg-gradient-to-b ${accent.tint} to-white rounded-2xl border border-slate-200/80 border-t-2 ${accent.border} p-4 xl:p-5 h-full flex flex-col`} data-id="element-16095">
                      <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3`} data-id="element-16096">
                        {accent.icon}
                      </div>
                      <h3 className="text-[15px] font-bold text-slate-900 mb-1 leading-tight" data-id="element-16097">
                        {card.title}
                      </h3>
                      <p className="text-slate-500 text-xs mb-3 flex-grow leading-relaxed" data-id="element-16098">
                        {card.desc}
                      </p>
                      <ul className="space-y-1.5 mb-4 text-xs text-slate-600" data-id="element-16099">
                        {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-16100">
                            <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-16101">
                              <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-16102" />
                            </div>
                            {f}
                          </li>)}
                      </ul>
                      <div className="text-xl font-bold text-slate-900 mb-3" data-id="element-16103">
                        {card.price}
                      </div>
                      <Button fullWidth variant="outline" className="text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-16104">
                        Выбрать
                      </Button>
                    </div>
                  </div>;
            })}
            </div>
          </div>
          <div className="text-center mt-5" data-id="element-16105">
            <Button variant="ghost" className="text-slate-500" onClick={() => onNavigate('pricing')} data-id="element-16106">
              Все цены и услуги <ArrowRight className="ml-2 w-4 h-4" data-id="element-16107" />
            </Button>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}